import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fp from 'lodash/fp';
import ArrowPrimary from '../../common/Icons/Arrow-Primary.svg';

const createExpanderCell = (
    ExpanderCellComponent = fp.noop,
    getIndentation = fp.constant(0),
    onClick = fp.noop
) => {
    const ExpanderCell = ({
        value, original, gridProps, ...props
    }) => (
        <div
            style={ {
                marginLeft: `${getIndentation(original)}px`
            } }
            className={ gridProps.styles['expander-cell'] }
            onClick={ useCallback(() => onClick(original, gridProps), [original, gridProps]) }
            role="none"
            title={ value }
        >
            <ExpanderCellComponent original={ original } gridProps={ gridProps } { ...props } />
            { original.children && value && (
                <div className={ gridProps.styles['expander-cell-svg-container'] }>
                    <img
                        alt=""
                        src={ ArrowPrimary }
                        className={ classNames({
                            [gridProps.styles['expander-cell-svg']]: true,
                            [gridProps.styles['expander-cell-svg-expanded']]: original.expanded
                        }) }
                    />
                </div>
            ) }
            <div className={ gridProps.styles['expander-cell-text'] }>{ value }</div>
        </div>
    );

    ExpanderCell.propTypes = {
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        original: PropTypes.shape({
            children: PropTypes.oneOfType([
                PropTypes.func,
                PropTypes.array]),
            expanded: PropTypes.oneOfType([
                PropTypes.func,
                PropTypes.bool])
        }).isRequired,
        gridProps: PropTypes.shape({
            styles: PropTypes.shape({
                'expander-cell': PropTypes.string,
                'expander-cell-svg': PropTypes.string,
                'expander-cell-svg-container': PropTypes.string,
                'expander-cell-svg-expanded': PropTypes.string,
                'expander-cell-text': PropTypes.string
            })
        })
    };

    ExpanderCell.defaultProps = {
        value: '',
        gridProps: {
            styles: {}
        }
    };

    return ExpanderCell;
};

export default createExpanderCell;
